/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'checkmark': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _stroke="currentColor" stroke-width="2.5" _fill="none" d="M1 8l4 4L15 2"/>'
  }
})
